import { useMemo, useCallback } from "react";

const useTableConfig = (showSAPColumns, customCaptions) => {
	const tableConfig = useMemo(() => {
		const headers = [
			customCaptions?.asset || "Asset Number",
			"Description",
		];
		const columns = ["assetNumber", "description"];

		if (showSAPColumns) {
			headers.splice(1, 0, customCaptions?.assetReference || "Reference");
			columns.splice(1, 0, "reference");

			headers.push(customCaptions?.assetPlannerGroup || "Planner Group");
			headers.push(customCaptions?.assetMainWorkCenter || "Work Center");
			columns.push("plannerGroup");
			columns.push("workCenter");
		}

		return { headers, columns };
	}, [showSAPColumns, customCaptions]);

	const getEditableData = useCallback((row) => {
		return {
			id: row.id,
			assetNumber: row.assetNumber || "",
			reference: row.reference || "",
			description: row.description || "",
			plannerGroup: row.plannerGroup || "",
			workCenter: row.workCenter || "",
		};
	}, []);

	return {
		tableConfig,
		getEditableData,
	};
};

export default useTableConfig;
